import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {Pageable, PageDataSort} from '../group-special-consideration/usePostGroupSCListing';
import {ApiPathParam} from '../../models/SearchParamSchema';
import {POST_NOTIFICATION_LISTING_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface NotificationListingRequest {
  notificationType: string;
  apiPathParam: ApiPathParam;
}

export interface NotificationListingResponseContentObject {
  uuid: string;
  title: string;
  sentDate: string;
  updatedBy: string;
  status: string;
  creator: boolean;
}

export interface NotificationListingResponse {
  content: NotificationListingResponseContentObject[];
  pageable: Pageable;
  last: boolean;
  totalElements: number;
  totalPages: number;
  first: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: PageDataSort[];
  empty: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: NotificationListingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostNotificationListing = ({onSuccess, onError}: Input = {}) => {
  const postNotificationListing = async (requestData: NotificationListingRequest) => {
    const res = await axiosClient.post<NotificationListingResponse>(
        POST_NOTIFICATION_LISTING_URL(requestData.apiPathParam),
        {
          notificationType: requestData.notificationType,
        }
    );
    return res.data;
  };

  return useCustomMutation(postNotificationListing, {
    onSuccess,
    onError,
  });
};
